import React, {Component, Fragment} from 'react';
import {firebaseActioner, auth} from '../firebase/firebase'


class Canvas
{
    constructor() {
        this.position = 40
        this.AddNewElementToBase = this.AddNewElementToBase.bind(this);
        this.DrawBorderOfElement = this.DrawBorderOfElement.bind(this);     
        this.DrawData = this.DrawData.bind(this);

    }

DrawData(temporaryDataModel)
{
    console.log("DrawData()", temporaryDataModel)
    let position = 100;
    let c = document.getElementById("myCanvas");
    let ctx = c.getContext("2d");
    ctx.clearRect(0,0,c.width, c.height);

    temporaryDataModel.project.forEach(element => {
        ctx.font = "50px Arial";
        ctx.fillText("Name: ",80,position); //(x,y)
        ctx.fillText(element.name,400,position); //(x,y)

        ctx.fillText("Surname: ",80,position+100); //(x,y)
        ctx.fillText(element.surname,400,position+100);
        
        ctx.fillText("Age: ",80,position+200); //(x,y)
        ctx.fillText(element.age,400,position+200);

        position = position+400
});
}

AddNewElementToBase(type, name, surname, age , documentID)
{    
    let func = this.DrawDataFromDataBase;

    var docRef = firebaseActioner.collection('Users').doc(auth.currentUser.uid).collection('projects').doc(documentID);

    docRef.get().then(function(doc) {
        if (doc.exists) {
            let project = doc.data().project;
            console.log("project", project);
            project.push(
                {
                    type: type,
                    name: name,
                    surname: surname,
                    age : age,
                    height: 400
                }
            );
            docRef.update(
            { 
                project
            }).then(func(documentID));
        } else {
             // doc.data() will be undefined in this case
             console.log("No such document!");
        }
        }).catch(function(error) {
        console.log("Error getting document:", error);
    })   
}

DrawBorderOfElement(index, posTop, posDown)
{
    var c = document.getElementById("myCanvas2");
    var ctx = c.getContext("2d");
    console.log("DrawBorderOfElement", "PostTop:" , posTop, "postDown:", posDown, "c.width:", c.width)
    ctx.beginPath();
    ctx.lineWidth = "9";
    ctx.strokeStyle = "green";
    ctx.rect(0,posTop, c.width, posDown-posTop);
    ctx.stroke();
}

ClearAdditionalCanvasLayer()
{
    var c = document.getElementById("myCanvas2");
    var ctx = c.getContext("2d");
    ctx.clearRect(0,0,c.width, c.height);
}

CanvasPage()
{
    var containerStyle = {
        position: "relative",
        width: window.innerWidth/2,
        height: "100%"
      }
      
    var canvasStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        width: window.innerWidth/2,
        height: "100%"
      }

    var divStyle = {
        border: '1px solid #000000',
        width: window.innerWidth/2,
        height: "100%",
      };
      
    
    return(
        <div width="400" height="400" style={containerStyle}>
            <canvas id="myCanvas" width="2480" height="3508" style={canvasStyle}></canvas>
            <canvas id="myCanvas2" width="2480" height="3508" style={canvasStyle}></canvas>
        </div>
    )
}
}

export default Canvas